<script>
export default {
  props: [ 'settings' ]
}
</script>

<template>
  <p>{{ settings.largetext }}</p>
</template>
